import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';
import { getErrorMessage } from '../../utils/helper';

const HOLIDAYS_ENDPOINT = '/holiday';

export const fetchHolidays = createAsyncThunk(
  'holidays/fetchHolidays',
  async ({ year, page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(HOLIDAYS_ENDPOINT, {
        params: { year, page, limit }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to fetch holidays'));
    }
  }
);

export const createHoliday = createAsyncThunk(
  'holidays/createHoliday',
  async (holidayData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(HOLIDAYS_ENDPOINT, holidayData);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to create holiday'));
    }
  }
);

export const updateHoliday = createAsyncThunk(
  'holidays/updateHoliday',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`${HOLIDAYS_ENDPOINT}/${id}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to update holiday'));
    }
  }
);

export const deleteHoliday = createAsyncThunk(
  'holidays/deleteHoliday',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(`${HOLIDAYS_ENDPOINT}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to delete holiday'));
    }
  }
); 